import { useRef } from "react"

import useScrollTo from "../../../hooks/use-scroll-to"
import PlanCard from "../components/plan-card"
import PlanHeader from "../components/plan-header"

import PlanDetails from "./plan-details"

const Plan = ({ plan, selectedPlanId, onSelect }) => {
  const {
    title,
    priceTitle,
    priceWithoutDiscounts,
    image,
    description,
    details,
    isSubscription,
    voucher,
    isRecommended,
    footnote,
  } = plan

  const { scrollTo } = useScrollTo()

  const planRef = useRef()

  const shouldSelect = selectedPlanId
    ? plan.id === selectedPlanId
    : plan.isSelected

  const handleClick = () => {
    onSelect(plan.id)

    planRef.current.addEventListener("transitionend", scrollToPlan)
  }

  const scrollToPlan = () => {
    setTimeout(() => {
      scrollTo({
        target: planRef.current,
      })

      planRef.current.removeEventListener("transitionend", scrollToPlan)
    }, 150)
  }

  return (
    <PlanCard
      isSelected={shouldSelect}
      plan={plan}
      isRecommended={isRecommended}
      onClick={handleClick}
      ref={planRef}
      sx={{
        display: "block",
      }}
    >
      <PlanHeader
        isSelected={shouldSelect}
        title={title}
        priceTitle={priceTitle}
        priceWithoutDiscounts={priceWithoutDiscounts}
        isSubscription={isSubscription}
      />
      <PlanDetails
        isSelected={shouldSelect}
        title={title}
        image={image}
        details={details}
        description={description}
        isSubscription={isSubscription}
        voucher={voucher}
        footnote={footnote}
      />
    </PlanCard>
  )
}

export default Plan
